/**
 * Token Management Utilities
 * Handles JWT token storage and retrieval
 */

const TOKEN_KEY = 'authToken';

/**
 * Store authentication token
 * Preferred: HttpOnly cookies (server-side)
 * Fallback: localStorage
 */
export const setAuthToken = (token: string): void => {
  localStorage.setItem(TOKEN_KEY, token);
};

/**
 * Get authentication token
 */
export const getAuthToken = (): string | null => {
  return localStorage.getItem(TOKEN_KEY);
};

/**
 * Remove authentication token
 */
export const removeAuthToken = (): void => {
  localStorage.removeItem(TOKEN_KEY);
};

/**
 * Check if user is authenticated
 */
export const isAuthenticated = (): boolean => {
  return !!getAuthToken();
};

/**
 * Store token from auth response
 */
export const storeAuthData = (tokenOrKey: string, user?: Record<string, unknown>): void => {
  // If first param is a token (starts with 'eyJ'), store it directly
  // Otherwise, it's a key and we need to get the token from user data
  if (tokenOrKey.startsWith('eyJ')) {
    setAuthToken(tokenOrKey);
  } else if (user && typeof user === 'object') {
    // Try to extract token from user object if it exists
    const token = (user.token as string) || (user.accessToken as string);
    if (token) {
      setAuthToken(token);
    }
  }
  
  if (user) {
    localStorage.setItem('user', JSON.stringify(user));
  }
};


/**
 * Clear all auth data
 */
export const clearAuthData = (): void => {
  removeAuthToken();
  localStorage.removeItem('user');
};

